import type { MsgId } from "@/messages";
import type { RouteType } from "@deskpro-product/messenger-api-schemas/messenger/config/routes";

export const routeTranslationMap: Record<RouteType, MsgId> = {
  HomeRoute: "Nav.home",
  HelpcenterRoute: "Nav.help",
  MessagesRoute: "Nav.messages",
  NewsRoute: "Nav.news",
};
